const salonLogo = (_id) => `/api/photos/logo/${_id}`

module.exports = salonLogo